// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"f9b8ec2e","726":"07b7d9b7"}[chunkId] + ".chunk.js";
};